import { render, staticRenderFns } from "./NhapMaKichHoatOtp.vue?vue&type=template&id=5535659e&scoped=true&"
import script from "./NhapMaKichHoatOtp.vue?vue&type=script&lang=js&"
export * from "./NhapMaKichHoatOtp.vue?vue&type=script&lang=js&"
import style0 from "./NhapMaKichHoatOtp.vue?vue&type=style&index=0&id=5535659e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5535659e",
  null
  
)

export default component.exports